import * as React from 'react';
import TreeNode from "./treeNode/TreeNode";
import * as styles from './TreeTargeting.css';
import { IItemData } from '../../interfaces/IItemData';
import { INode } from '../../interfaces/INode';
import { INodeGroup } from '../../interfaces/INodeGroup';
import { ITargetingTerm } from '../../interfaces/ITargetingTerm';
import { ITerm } from '../../interfaces/ITerm';
import { TargetingService } from '../../services/TargetingService';
import { IACheckbox } from '../checkbox/Checkbox';
import { IAIcon } from '../icon/Icon';
import { IAToggle } from '../toggle/Toggle';
import { IAChoiceGroup } from '../choiceGroup/ChoiceGroup';
import { LocalizationService } from '../../services/LocalizationService';
import { ITargetingFields } from '../../interfaces/ITargetingFields';
import { ITargetingGroup } from '../../interfaces/ITargetingGroup';
import { ITargetingApplications } from '../../interfaces/ITargetingApplications';
import { IASpinner } from './../spinner/Spinner';
import { ITargetingExistingStrucuture } from '../../interfaces/ITargetingExistingStructure';
import * as mobx from 'mobx';
import { IATooltip } from '../tooltip/Tooltip';

export interface ITreeTargetProps {
  operator: string;
  application: "messages" | "navigator" | "toolbox" | "events" | "content organizer" | "app";
  environment: "Development" | "Test" | "Production";
  applicationData?: ITargetingApplications;
  tenant: string;
  apiUrl: string;
  authToken: string;
  selectedValues: IItemData[];
  showTarget: boolean;
  nodeComparison: "id" | "label";
  highlightColor: string;
  label?: string;
  instance?: string;
  onLogicalOperatorChanged: (string) => void;
  onChange: (result: ITargetingFields[], applicationSettings: ITargetingApplications, groupResult: ITargetingGroup[], selectAll?: boolean, existingNodes?: ITargetingExistingStrucuture) => void;
  onShowTargetChanged: (boolean) => void;
  hideOptions?: boolean;
  showSelectAll?: boolean;
  selectAll?: boolean;
  isAdmin?: boolean;
  currenNodeStructure?: ITargetingExistingStrucuture;
  required?: boolean;
  toolTip?: string;
  checkBoxBorderColor?: string;
  disabled?: boolean;
  useForTargetingPreview?: boolean;
}

export interface ITreeTargetState {
  nodes: INode[];
  operator: string;
  disableOperator: boolean;
  showTarget: boolean;
  applicationSettings: ITargetingApplications;
  selectAll?: boolean;
  targetTerms: ITargetingTerm[];
  isLoading: boolean;
}

enum ParentState {
  Unchecked = 0,
  PartChecked = 1,
  Checked = 2
}

export class TreeTargeting extends React.Component<ITreeTargetProps, ITreeTargetState> {

  private nodeComparison: string;

  public constructor(props: ITreeTargetProps) {
    super(props);
    this.state = {
      nodes: [],
      operator: this.props.operator ? this.props.operator : "AND",
      disableOperator: true,
      showTarget: this.props.showTarget,
      applicationSettings: null,
      selectAll: props.selectAll,
      targetTerms: [],
      isLoading: true
    };

    this.formatResult = this.formatResult.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.findNode = this.findNode.bind(this);
    this.onUpdateNodeItem = this.onUpdateNodeItem.bind(this);
    this.selectOperator = this.selectOperator.bind(this);
    // this.renderNodes = this.renderNodes.bind(this);

    this.nodeComparison = this.props.nodeComparison ? this.props.nodeComparison : "label";
  }

  public componentDidMount(): void {
    if (!this.state.nodes || this.state.nodes.length === 0) {
      if (!this.props.applicationData) {
        TargetingService.getAllTerms(this.props.environment, this.props.tenant, this.props.authToken).then(terms => {
          this.setState({ targetTerms: terms, isLoading: false }, () => {
            this.renderNodes();
          });
        });
      } else {
        this.renderNodes();
      }
    } else if (this.props.applicationData) {
      this.setState({
        // nodes: [],
        operator: this.props.operator ? this.props.operator : "AND",
        disableOperator: true,
        showTarget: this.props.showTarget,
        targetTerms: this.props.applicationData ? this.props.applicationData.targetingTerms : this.state.targetTerms,
        selectAll: this.props.selectAll
      }, () => this.renderNodes());
    }
    if (!this.state.nodes || this.state.nodes.length === 0) {
      this.renderNodes();
    }
  }

  public componentWillReceiveProps(props: ITreeTargetProps): void {
    if ((props.application !== this.props.application) && !props.applicationData) {
      this.setState({ isLoading: true }, () => {
        TargetingService.getAllTerms(props.environment, props.tenant, props.authToken).then(terms => {
          this.setState({
            // nodes: [],
            operator: props.operator ? props.operator : "AND",
            disableOperator: true,
            showTarget: props.showTarget,
            targetTerms: terms,
            isLoading: false,
            selectAll: props.selectAll
          }, () => this.renderNodes());
        });
      });
    } else {
      this.setState({
        // nodes: [],
        operator: props.operator ? props.operator : "AND",
        disableOperator: true,
        showTarget: props.showTarget,
        targetTerms: props.applicationData ? props.applicationData.targetingTerms : this.state.targetTerms,
        selectAll: props.selectAll
      }, () => this.renderNodes());
    }
  }

  public render(): React.ReactElement<ITreeTargetProps> {

    const data = this.state.nodes;
    let displayAndOr = true;

    if (this.props.isAdmin) {
      displayAndOr = false;
    } else if (this.props.applicationData && this.props.applicationData.application && this.props.applicationData.application.default) {
      displayAndOr = this.props.applicationData.application.default.type !== "userGroups";
    }

    let label = <div style={{ float: "left" }}>{this.props.label}</div>;
    if (this.props.required) {
      label = <div style={{ float: "left" }}>{this.props.label} <span style={{ color: "red" }}>*</span></div>;
    }
    return (
      <div
        style={{
          clear: "both"
        }}
      >
        {this.state.isLoading && this.props.isAdmin &&
          <div>
            <IASpinner style={{ display: 'inline-flex', position: 'relative', left: '25%', width: "12px", height: "12px" }} />
          </div>
        }
        {!this.props.hideOptions ?
          <div
            style={{
              clear: "both"
            }}
          >
            <IAToggle
              label={this.props.label !== undefined ? this.props.label : new LocalizationService().strings.TargetTree_WhoShouldSeeThis}
              checked={this.state.showTarget}
              color={this.props.highlightColor}
              toolTip={this.props.toolTip}
              onChange={() => {
                this.setState({ showTarget: !this.state.showTarget }, () => {
                  this.props.onShowTargetChanged(this.state.showTarget);
                });
              }}
            />
          </div>
          :
          <div>
            {label}
            {this.props.toolTip && this.props.toolTip !== "" &&
              <IATooltip
                content="Tooltip"
                type={window.innerWidth < 667 ? "popup" : "bubble"}
                styles={{
                  textAlign: "left",
                  color: "#333333"
                }}
                componentContent={
                  <div>
                    {this.props.toolTip}
                  </div>
                }
              >
                <IAIcon
                  title="Info"
                  size={14}
                  color={this.props.highlightColor !== undefined ? this.props.highlightColor : "#03787c"}
                  style={{
                    float: "left",
                    cursor: "pointor",
                    marginLeft: 4,
                    marginTop: 2,
                    height: 13
                  }}
                />
              </IATooltip>
            }
          </div>
        }
        {(!(this.state.isLoading && this.props.isAdmin) && this.state.showTarget && data != null || this.state.showTarget && data.length != 0) ?
          ((data != undefined) ?
            <div>
              <div style={{ clear: "both" }}>
                <div className={styles.panelGrid} style={{ paddingTop: !this.props.hideOptions ? '20px' : 0 }}>
                  {!this.props.hideOptions &&
                    <label>{new LocalizationService().strings.TargetTree_WhoShouldSeeThis}</label>
                  }
                  <div className={styles.list}>
                    {this.props.showSelectAll &&
                      <IACheckbox
                        disabled={this.props.disabled}
                        key={`checkBox_selectAll`}
                        isChecked={this.state.selectAll}
                        onChange={() => {
                          this.setState({ selectAll: this.state.selectAll ? !this.state.selectAll : true }, () => {
                            this.updateAllNodes(this.state.selectAll);
                          });
                        }}
                        label={new LocalizationService().strings.TargetTree_All}
                        defaultColor="#cccccc"
                        highlightColor={this.props.highlightColor}
                        borderColor={this.props.checkBoxBorderColor}
                      />}
                    {
                      data.map((item) => {
                        return (<div key={item.title}>
                          {item.childNodes && item.childNodes.length > 0 &&
                            <IAIcon
                              url={item.expand ? 'https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg' : 'https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg'}
                              size={18}
                              color={this.props.highlightColor}
                              name={item.title}
                              onClick={() => this.expandCollapse(item.title)}
                              style={{
                                float: "left",
                                clear: "left",
                                cursor: "pointer",
                                marginTop: 2,
                                marginRight: 10,
                                marginLeft: -28
                              }}
                            />}
                          <IACheckbox
                            key={`checkBox_${item.title}`}
                            disabled={this.props.disabled}
                            isChecked={item.checked}
                            onChange={this.handleChange}
                            name={item.title}
                            label={item.defaultLabel}
                            marked={item.markedChild}
                            defaultColor="#cccccc"
                            highlightColor={this.props.highlightColor}
                            borderColor={this.props.checkBoxBorderColor}
                          />
                          {item.childNodes && item.childNodes.length > 0 && item.expand &&
                            <TreeNode
                              nodes={item.childNodes}
                              parent={item}
                              onUpdateNode={this.onUpdateNodeItem}
                              marginLeft={28}
                              highlightColor={this.props.highlightColor}
                              borderColor={this.props.checkBoxBorderColor}
                            />
                          }
                        </div>
                        );
                      })}
                  </div>
                  {displayAndOr &&

                    <IAChoiceGroup
                      className={styles.defaultChoiceGroup}
                      selectedKey={this.state.operator}
                      highlightColor={this.props.highlightColor}
                      options={[
                        {
                          key: 'AND',
                          text: new LocalizationService().strings.TargetTree_Operator_And,
                          disabled: this.state.disableOperator
                        },
                        {
                          key: 'OR',
                          text: new LocalizationService().strings.TargetTree_Operator_Or,
                          disabled: this.state.disableOperator
                        }
                      ]}
                      required={true}
                      onChange={this.selectOperator}
                    />
                  }
                </div>
              </div>
            </div>
            :
            <div style={{
              float: "left",
              width: "100%",
              clear: "both"
            }}>
              <IASpinner />
            </div>
          )
          :
          <div></div>
        }
      </div>
    );
  }

  public handleChange(isChecked, name) {
    const node = this.findNode(name);
    const status = isChecked;

    node.checked = status;
    if (node != null && node.childNodes != null && node.childNodes.length > 0) {
      this.changeChildrenStatus(node, status);
      if (status) {
        node.markedChild = true;
      } else {
        node.markedChild = false;
      }
    }
    let count = 0;
    this.state.nodes.forEach((stateNode) => {
      if (stateNode.markedChild) {
        count++;
      }
    });

    this.checkIfAllAreSelected(this.state.nodes);
    this.setState({ nodes: this.state.nodes, disableOperator: count > 1 ? false : true }, () => {
      this.onChange(this.formatResult());
    });
  }

  private checkIfAllAreSelected = (nodes) => {
    let itemsCount = 0;
    let itemsChecked = 0;

    nodes.forEach((node) => {
      if (node.title !== "All") {
        const result = this.checkIfAllChildrenAreSelected(node, itemsCount, itemsChecked);
        itemsCount = result[0];
        itemsChecked = result[1];
      }
    });

    if (itemsCount === itemsChecked) {
      this.setState({ selectAll: true });
    } else {
      this.setState({ selectAll: false });
    }
  }

  private checkIfAllChildrenAreSelected = (parent: INode, itemsCount, checkedCount): [number, number] => {
    if (parent.childNodes && parent.childNodes.length > 0) {
      parent.childNodes.forEach((child) => {
        const result = this.checkIfAllChildrenAreSelected(child, itemsCount, checkedCount);
        itemsCount = result[0];
        checkedCount = result[1];
      });
    }

    if (parent.checked) {
      checkedCount++;
    }

    itemsCount++;
    return [itemsCount, checkedCount];
  }

  private onChange(result: any): void {

    const existingStructure: ITargetingExistingStrucuture = {
      useDefaultStructure: true,
      nodes: this.state.nodes
    };

    this.props.onChange(result, this.state.applicationSettings, result, this.state.selectAll, existingStructure);
  }

  private formatResult(): any {

    const nodes = this.state.nodes;
    const groupNodes = this.getGroupNodes(nodes);

    const targetingDataModel = [];

    groupNodes.forEach((node) => {
      targetingDataModel.push({
        field: node.title,
        name: node.title.replace('IATargeting', '').toLowerCase(),
        values: node.values,
        id: node.id
      });
    });

    return targetingDataModel;
  }

  private changeChildrenStatus(node: INode, status: boolean) {
    node.childNodes.forEach((child) => {
      if (!!child.childNodes && child.childNodes.length > 0) {
        this.changeChildrenStatus(child, status);
        if (status) {
          child.markedChild = true;
        } else {
          child.markedChild = false;
        }
      }
      child.checked = status;
    });
  }

  private findNode(id: string, useId?: boolean): INode {
    let selectedNode: INode;
    this.state.nodes.forEach((node) => {

      if (!useId) {
        if (node.title === id) {
          selectedNode = node;
        }
      } else {
        if (node.id === id) {
          selectedNode = node;
        }
      }

    });
    return selectedNode;
  }

  private expandCollapse(name) {
    let term = this.findNode(name);
    term.expand = !term.expand;
    this.setState({ nodes: this.state.nodes }, () => this.forceUpdate());
  }

  public onUpdateNodeItem(node: INode) {
    let checked = true;
    let parentState: ParentState;
    parentState = ParentState.Unchecked;

    node.childNodes.forEach((child) => {
      if (!child.checked) {
        checked = false;
      } else {
        parentState = ParentState.PartChecked;
      }
    });
    if (checked) {
      parentState = ParentState.Checked;
    }

    switch (parentState) {
      case ParentState.Unchecked:
        node.checked = false;
        node.markedChild = false;
        break;
      case ParentState.Checked:
        node.checked = true;
        node.markedChild = true;
        break;
    }

    const nodes = [];

    this.state.nodes.forEach((x) => {
      if (x.defaultLabel !== node.defaultLabel) {
        nodes.push(x);
      } else {
        nodes.push(node);
      }
    });

    const amountSelectedChild = nodes.filter(n => !!n.markedChild).length;
    this.checkIfAllAreSelected(nodes);
    this.setState({ nodes: nodes, disableOperator: amountSelectedChild > 1 ? false : true }, () => {
      this.onChange(this.formatResult());
    });
  }

  private selectOperator(option: any) {
    this.props.onLogicalOperatorChanged(option);
    this.setState({ operator: option });
  }

  private updateAllNodes(value: boolean) {
    const nodes = this.state.nodes;
    nodes.forEach((node) => {
      node.checked = value;
      node.markedChild = value;
      if (node.childNodes != null && node.childNodes.length > 0) {
        this.updateNodes(node.childNodes, value);
      }
    });
    this.setState({ nodes }, () => {
      this.onChange(this.formatResult());
    });
  }

  private updateNodes(nodes: INode[], value: boolean) {
    nodes.forEach((node) => {
      node.checked = value;
      node.markedChild = value;
      if (node.childNodes != null && node.childNodes.length > 0) {
        this.updateNodes(node.childNodes, value);
      }
    });
  }

  private getGroupNodes(nodes: INode[]) {
    const returns: INodeGroup[] = [];
    nodes.forEach((node) => {
      let list: IItemData[] = [];
      if (node.childNodes === null || node.childNodes.length === 0) {

        if (node.checked) {
          returns.push({
            field: node.defaultLabel,
            values: list,
            title: node.title,
            id: node.id
          });
        }
      } else {
        if (node.childNodes != null && node.childNodes.length > 0) {
          list = list.concat(this.getSelectedNodes(node.childNodes, node.title));
        }
        if (list && list.length > 0) {
          returns.push({
            field: node.defaultLabel,
            values: list,
            title: node.title,
            id: node.id
          });
        }
      }
    });
    return returns;
  }

  private getSelectedNodes(nodes: INode[], field: string): IItemData[] {
    let list: IItemData[] = [];
    nodes.forEach((node) => {
      if (node.checked) {
        list.push({ id: node.id, label: node.defaultLabel, field: field });
      }
      if (node.childNodes != null && node.childNodes.length > 0) {
        list = list.concat(this.getSelectedNodes(node.childNodes, node.title));
      }
    });
    return list;
  }

  private groupBy = (list, keyGetter) => {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  private renderNodes = () => {

    const application = this.props.applicationData;
    const selectedValues = this.props.selectedValues;

    if (application && application.applicationSettings) {

      let listNodes: INode[] = [];
      let terms = [];
      let amountSelectedChild = 0;
      let selectedAll = false;


      if (application.targetingTerms) {
        terms = application.targetingTerms;
      } else if ((!!this.state.targetTerms && this.state.targetTerms.length > 0)) {
        terms = this.state.targetTerms;
      }

      if (application?.applicationSettings?.toLowerCase() === "profile data" && application?.application?.default?.type === "profileData") { // Profile Data

        if (!this.props.currenNodeStructure || !this.props.currenNodeStructure.useDefaultStructure) {

          // Check values for an instance
          if (application.application && this.props.instance) {
            const currentInstanceSettings = application ? application.application.instances.find(x => x.id === this.props.instance || x.name === this.props.instance || ((this.props.instance === "Default" && x.name === this.props.instance) || (this.props.instance === "Default" && x.id === ""))) : undefined;
            if (currentInstanceSettings && !currentInstanceSettings.useDefault && currentInstanceSettings.type === "profileData") {
              // It should use the values selected for the specific instance
              if (currentInstanceSettings.values && currentInstanceSettings.values.length > 0) {
                const grouped = this.groupBy(currentInstanceSettings.values, v => v.field);
                this.handleProfileDataDefaultValues(listNodes, true, grouped, terms);
              }
            } else {
              // It should use the default values from the application
              if (application.application.default.values) {
                const grouped = this.groupBy(application.application.default.values, v => v.field);
                this.handleProfileDataDefaultValues(listNodes, true, grouped, terms);
              }
            }
          } else if (application.application && !this.props.instance) { // When we don't have instances
            // const defaultValues = JSON.parse(application.defaultValues);
            if (application.application.default && application.application.default.type && application.application.default.type === "profileData") {
              if (application.application.default.values) {
                const grouped = this.groupBy(application.application.default.values, v => v.field);
                this.handleProfileDataDefaultValues(listNodes, true, grouped, terms);
              }
            }
          } else {
            if (this.state.nodes && this.state.nodes.length > 0 && (selectedValues && selectedValues.length === 0)) {
              listNodes = this.state.nodes;
            } else {
              const grouped = this.groupBy(selectedValues, v => v.field);
              this.handleProfileDataDefaultValues(listNodes, false, grouped, terms);
            }
          }
        } else { // Using the values selected from the previous structure
          this.props.currenNodeStructure.nodes.forEach((node) => {
            const childNodes = mobx.toJS(node.childNodes);
            listNodes.push({
              defaultLabel: node.defaultLabel,
              id: node.id,
              childNodes: childNodes,
              labels: node.labels,
              columnName: node.columnName,
              markedChild: node.markedChild,
              checked: node.checked,
              expand: node.expand,
              title: node.title
            });
          });
        }

        amountSelectedChild = listNodes.filter(n => !!n.markedChild).length;
        selectedAll = listNodes.filter(n => !!n.checked).length === listNodes.length;

      } else { // User Groups

        let groups = application ? application.targetingGroups : undefined;

        if (!this.props.useForTargetingPreview) {
          // Checking if the current instance will use default values or not
          if (application.application && this.props.instance) {

            const currentInstanceSettings = application.application.instances.find(x => x.name === this.props.instance || x.id === this.props.instance || ((this.props.instance === "Default" && x.name === this.props.instance) || (this.props.instance === "Default" && x.id === "")));
            if (currentInstanceSettings) {

              // Checking if will not use Default AND that the Current instance type is USER GROUPS
              if (!currentInstanceSettings.useDefault && currentInstanceSettings.type === "userGroups") {
                groups = [];

                if (currentInstanceSettings.values && currentInstanceSettings.values.length > 0) {
                  currentInstanceSettings.values.forEach((v) => {
                    if (v.value) {
                      groups.push({
                        id: v.id,
                        title: v.label,
                        values: undefined
                      });
                    }
                  });
                }
              } else {
                const groupDataApplication = application.application.default && application.application.default.values ? application.application.default.values.filter(x => x.value) : undefined;
                groups = [];

                if (groupDataApplication) {
                  groupDataApplication.forEach((g) => {
                    groups.push({
                      id: g.id,
                      title: g.label,
                      values: undefined
                    });
                  });
                }
              }
            }
          } else if (application.application && !this.props.instance) { // When we don't have instances
            if (application.application.default && application.application.default.type && application.application.default.type === "userGroups") {
              groups = [];
              if (application.application.default.values) {
                application.application.default.values.forEach((x) => {
                  groups.push({
                    id: x.id,
                    title: x.label,
                    values: undefined
                  });
                });
              }
            }
          } else if (!application.application && application.defaultValues) { // When we don't have the application defined
            const defaultValues = JSON.parse(application.defaultValues);
            if (defaultValues.default && defaultValues.default.type && defaultValues.default.type === "userGroups") {
              groups = [];
              if (defaultValues.default.values) {
                defaultValues.default.values.forEach((x) => {
                  groups.push({
                    id: x.id,
                    title: x.label,
                    values: undefined
                  });
                });
              }
            }
          }
        }

        if (!!groups && groups.length > 0) {
          groups = groups.sort((g1, g2) => {
            if (g1.title.toLocaleLowerCase() > g2.title.toLocaleLowerCase()) {
              return 1;
            }
            if (g1.title.toLocaleLowerCase() < g2.title.toLocaleLowerCase()) {
              return -1;
            }
            return 0;
          });

          groups.forEach(group => {
            let node = this.convertGroupToNode(group);
            node = this.verifyCheckedGroupDataNode(node, selectedValues, group.id);
            listNodes.push({
              defaultLabel: node.defaultLabel,
              checked: node.checked,
              childNodes: [],
              id: node.id,
              labels: [],
              columnName: group.title,
              title: group.title,
              markedChild: false
            });
          });
        }

        amountSelectedChild = listNodes.filter(n => !!n.checked).length;
        selectedAll = amountSelectedChild === listNodes.length;
      }

      // Diplaying the results for the administrator
      this.setState({ isLoading: false, nodes: listNodes, disableOperator: amountSelectedChild > 1 ? false : true, applicationSettings: application, selectAll: selectedAll });

    } else {

      if (this.props.isAdmin) {
        let listNodes: INode[] = [];
        let terms = [];

        if ((!!this.state.targetTerms && this.state.targetTerms.length > 0)) {
          terms = this.state.targetTerms;
        }

        if (!this.props.currenNodeStructure || !this.props.currenNodeStructure.useDefaultStructure) {

          if (this.state.nodes && this.state.nodes.length > 0 && (selectedValues && selectedValues.length === 0)) {
            listNodes = this.state.nodes;
          } else {
            const grouped = this.groupBy(selectedValues, v => v.field);
            this.handleProfileDataDefaultValues(listNodes, false, grouped, terms);
          }
        } else { // Using the values selected from the previous structure
          this.props.currenNodeStructure.nodes.forEach((node) => {
            const childNodes = mobx.toJS(node.childNodes);
            listNodes.push({
              defaultLabel: node.defaultLabel,
              id: node.id,
              childNodes: childNodes,
              labels: node.labels,
              columnName: node.columnName,
              markedChild: node.markedChild,
              checked: node.checked,
              expand: node.expand,
              title: node.title
            });
          });
        }

        // Diplaying the results for the administrator
        const amountSelectedChild = listNodes.filter(n => !!n.markedChild).length;
        this.checkIfAllAreSelected(listNodes);
        this.setState({ isLoading: false, nodes: listNodes, disableOperator: amountSelectedChild > 1 ? false : true, applicationSettings: application });

      } else {
        // Displaying the spinner while the data is not received
        this.setState({ isLoading: true });
      }
    }
  }

  private handleProfileDataDefaultValues = (listNodes, checkValues: boolean, groupedList, terms: any[]) => {

    if (terms && terms.length > 0) {
      terms = terms.sort((t1, t2) => {
        if (t1.displayName.toLocaleLowerCase() > t2.displayName.toLocaleLowerCase()) {
          return 1;
        }
        if (t1.displayName.toLocaleLowerCase() < t2.displayName.toLocaleLowerCase()) {
          return -1;
        }
        return 0;
      });

      terms.forEach((_term) => {

        const term = this.capitalizeKeys(_term) as ITargetingTerm;
        const groupedId = groupedList && checkValues ? groupedList.get(term.InternalName) : undefined;

        if (checkValues && !groupedId) {
          return;
        }

        const childrenStrValidated = this.escapeSpecialChars(JSON.stringify(term.Children));
        const termValues = JSON.parse(childrenStrValidated) as ITerm[];
        let nodes = this.convertTermSet(termValues, term.InternalName, groupedId);

        const checkedList = this.props.selectedValues;
        if (checkedList !== undefined) {
          const checkListFiltered = checkedList.filter(c => !c.field || c.field === term.InternalName);
          nodes = this.verifyCheckedNodes(nodes, checkListFiltered, null, term);
        }

        const flags = this.checkNodeStateChild(nodes, {
          checked: false,
          markedChild: false,
          amountChecked: 0,
          amountOfItems: 0
        });

        flags.checked = flags.amountChecked === flags.amountOfItems;

        listNodes.push({
          defaultLabel: term.DisplayName,
          id: term.Id,
          childNodes: nodes,
          checked: flags.checked,
          labels: [],
          columnName: term.DisplayName,
          markedChild: flags.markedChild,
          title: term.InternalName
        });
      });
    }
  }

  private convertTermSet(terms: ITerm[], termInternalName: string, itemsToKeep) {
    const nodes: INode[] = [];
    terms.forEach((term) => {
      const returnedItem = this.convertTermToNode(term, termInternalName, itemsToKeep);
      if (returnedItem) {
        nodes.push(returnedItem);
      }
    });
    return nodes;
  }


  private convertGroupToNode(group: ITargetingGroup) {
    const list: INode[] = [];
    const node: INode = {
      childNodes: list,
      id: group.id,
      defaultLabel: group.title,
      title: group.title,
      checked: false,
      labels: []
    };

    return node;
  }

  private convertTermToNode(term: ITerm, termInternalName: string, itemsToKeep) {
    const list: INode[] = [];
    if (term.ChildTerms) {
      term.ChildTerms.forEach((t) => {
        const returnedNode = this.convertTermToNode(t, termInternalName, itemsToKeep);
        if (returnedNode) {
          list.push(returnedNode);
        }
      });
    }

    if (itemsToKeep) {
      const checkItem = itemsToKeep.find(x => x.id === term.Id);
      if (!checkItem && list.length === 0) {
        return undefined;
      }
    }

    const node: INode = {
      childNodes: list,
      id: term.Id,
      defaultLabel: term.DefaultLabel,
      title: termInternalName,
      checked: false,
      labels: []
    };

    return node;
  }

  private verifyCheckedNodes(nodes: INode[], checkedList: IItemData[], parentNode: INode = null, term: any = null): INode[] {
    const nodeComparison_ = this.nodeComparison;
    nodes.forEach((node) => {
      const items = checkedList.filter(l => ((nodeComparison_ === "id" && l.id === node.id) || (nodeComparison_ === "label" && l.label === node.defaultLabel)));
      if (items && items.length > 0) {
        if (!term || !items[0].field || (term && items[0].field && items[0].field === term.InternalName) || (parentNode == null || parentNode.checked)) {
          node.checked = true;
        }
      }
      if (node.childNodes && node.childNodes.length > 0) {
        node.childNodes = this.verifyCheckedNodes(node.childNodes, checkedList, node, term);

        // Checking if there is any child cheked
        const childChecked = node.childNodes.filter(x => x.checked);
        node.markedChild = childChecked && childChecked.length > 0;
      }
    });
    return nodes;
  }

  private verifyCheckedGroupDataNode = (node: INode, checkedList: IItemData[], group: string): INode => {

    if (node.id) {
      const items = checkedList ? checkedList.filter(l => l.id && l.id.toString() === node.id.toString()) : [];
      if (items && items.length > 0) {
        if (!group || !items[0].field || (group && items[0].field && items[0].field === group)) {
          node.checked = true;
        }
      }
    }
    return node;
  }

  private checkNodeState(nodes: INode[]): boolean {
    let checked = true;
    nodes.forEach((node) => {

      checked = node.checked;
      if (checked && node.childNodes && node.childNodes.length > 0) {
        checked = this.checkNodeState(node.childNodes);
      }
    });
    return checked;
  }

  private checkNodeStateChild(nodes: INode[], returnValue: {
    checked: boolean,
    markedChild: boolean,
    amountOfItems: number,
    amountChecked: number
  }) {


    nodes.forEach((node) => {

      if (node.checked) {
        returnValue.markedChild = true;
        returnValue.checked = true;
        returnValue.amountChecked++;
      }

      returnValue.amountOfItems++;

      if (returnValue.checked && node.childNodes && node.childNodes.length > 0) {
        returnValue = this.checkNodeStateChild(node.childNodes, returnValue);
      }
    });
    return returnValue;
  }

  private checkIfHasOneChecked(nodes: INode[]) {
    nodes.forEach((node) => {

      if (node.checked) {
        return true;
      }

      if (node.childNodes && node.childNodes.length > 0) {
        return this.checkIfHasOneChecked(node.childNodes);
      }

    });
  }

  private capitalizeKeys = (obj) => {
    const isObject = o => Object.prototype.toString.apply(o) === '[object Object]';
    const isArray = o => Object.prototype.toString.apply(o) === '[object Array]';

    const transformedObj = isArray(obj) ? [] : {};
    const _obj = isArray(obj) ? Array.from(obj) : obj;
    for (const key in _obj) {
      // replace the following with any transform function
      const transformedKey = key.replace(/^\w/, (c, _) => c?.toUpperCase());

      if (isObject(obj[key]) || isArray(obj[key])) {
        transformedObj[transformedKey] = this.capitalizeKeys(obj[key]);
      } else {
        transformedObj[transformedKey] = obj[key];
      }
    }
    return transformedObj;
  }

  private escapeSpecialChars(jsonString: string): string {
    return jsonString.replace(/\n/g, "\\n")
      .replace(/\r/g, "\\r")
      .replace(/\t/g, "\\t")
      .replace(/\f/g, "\\f")
      .replace(/'/g, '"');
  }
}